import useModal from '@/common/hooks/useModal';

const useAddDamagedPerson = () => {
  const modal = useModal();
  const addDamagedPerson = () => {
    modal.openModal();
  };

  return { addDamagedPerson, modal };
};

export default useAddDamagedPerson;
